"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function setCursor(a) {
  var b = a.cursorValue,
      c = a.className,
      d = document.querySelector("html");
  document.body && d && (d.className = c, document.body.setAttribute("style", b));
}

function setGlobalCursor(a) {
  setCursor({
    cursorValue: "cursor: ".concat(a, " !important"),
    className: "reset-all-cursors"
  });
}

function resetGlobalCursor() {
  setCursor({
    cursorValue: "cursor: ''",
    className: ""
  });
}

var _default = {
  set: setGlobalCursor,
  reset: resetGlobalCursor
};
exports["default"] = _default;